export enum CustomerCategory {
  VAREJO = 'Varejo',
  ATACADO = 'Atacado',
  CORPORATIVO = 'Corporativo',
  GOVERNO = 'Governo',
  DISTRIBUIDOR = 'Distribuidor',
  REVENDA = 'Revenda',
  INDUSTRIA = 'Indústria',
  PRESTADOR_SERVICOS = 'Prestador de Serviços',
  OUTROS = 'Outros'
}

export const CUSTOMER_CATEGORY_OPTIONS = [
  { value: CustomerCategory.VAREJO, label: 'Varejo' },
  { value: CustomerCategory.ATACADO, label: 'Atacado' },
  { value: CustomerCategory.CORPORATIVO, label: 'Corporativo' },
  { value: CustomerCategory.GOVERNO, label: 'Governo' },
  { value: CustomerCategory.DISTRIBUIDOR, label: 'Distribuidor' },
  { value: CustomerCategory.REVENDA, label: 'Revenda' },
  { value: CustomerCategory.INDUSTRIA, label: 'Indústria' },
  { value: CustomerCategory.PRESTADOR_SERVICOS, label: 'Prestador de Serviços' },
  { value: CustomerCategory.OUTROS, label: 'Outros' }
];

export const CUSTOMER_CATEGORY_FILTER_OPTIONS = [
  { value: '', label: 'Todas as Categorias' },
  ...CUSTOMER_CATEGORY_OPTIONS
];
